import React from "react";
import Layout from "./Layout";
import { useState } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom/dist";
import { addDoc, collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db,storage } from "../../../config/firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import {
  createInitialForm,
  fetchLatestId,
  updateLatestId,
  validateRequiredField,
} from "../../../common/common";
import { vendorData } from "../../../assets/lib/vendor";
import { COLLECTION, COLLECTION_COUNTER } from "../../../data/constant";
import { routes } from "../../../routing/routes";

const VendorInfo = () => {
  const { vendorDocId } = useParams();
  const navigate = useNavigate();
  const [isEdit, setIsEdit] = useState(false);
  const [isNewAdd, setIsNewAdd] = useState(true);
  const { state: locationState } = useLocation();
  const [vendorState, setVendorState] = useState(createInitialForm(vendorData));
  const [errorFields, setErrorFields] = useState([]);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [errorOnFetch, setErrorOnFetch] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadedImage, setUploadedImage] = useState(null);



  const handleSubmitModal = async () => {
    const error = validateRequiredField(vendorData, vendorState);
    vendorState.inventory = {}
    vendorState.podsForVendor = []
    vendorState.vendorProducts = []
    setErrorFields(error);
    setSubmitLoading(true);
    if (error.length === 0) {
      try {

          let fileUrl = "";
                    
                    // Check if a file has been uploaded
                    if (uploadedFile) {
                      // Create a storage reference
                      const storageRef = ref(
                        storage, 
                        `Documents/${Date.now()}_${uploadedFile.name}`
                      );
              
                      // Upload the file to Firebase Storage
                      const uploadResult = await uploadBytes(storageRef,uploadedFile);
                      console.log("File uploaded:", uploadResult);
              
                      // Get the file's download URL
                      fileUrl = await getDownloadURL(storageRef);
                      console.log("File URL:", fileUrl);
              
                      // Attach file URL to vendorState
                      vendorState.documentUrl = fileUrl;
                    }

                     let imageUrl = "";
                              
                              // Check if a file has been uploaded
                              if (uploadedImage) {
                                // Create a storage reference
                                const storageRef = ref(
                                  storage, 
                                  `Images/${Date.now()}_${uploadedImage.name}`
                                );
                        
                                // Upload the file to Firebase Storage
                                const uploadResult = await uploadBytes(storageRef,uploadedImage);
                                console.log("Image uploaded:", uploadResult);
                        
                                // Get the file's download URL
                                imageUrl = await getDownloadURL(storageRef);
                                console.log("File URL:", fileUrl);
                        
                                // Attach file URL to vendorState
                                vendorState.imageUrl = imageUrl;
                              }


        if (isEdit && vendorDocId) {
          // save edited data
          const docRef = doc(db, COLLECTION.VENDOR, vendorDocId);
          await updateDoc(docRef, vendorState);
        } else {
          // Add new data
          const vendorCollectionRef = collection(db, COLLECTION.VENDOR);
          await addDoc(vendorCollectionRef, vendorState);
          await updateLatestId(COLLECTION_COUNTER.VENDOR, vendorState.vendorId);
        }
        setSubmitLoading(false);
        navigate(routes.VENDOR_MANAGEMENT);
      } catch (error) {
        setSubmitLoading(false);
        console.log("error", error);
        setErrorOnFetch(true);
      }
    }
  };

  const getVendorInput = (event) => {
    // If the page is open in view state
    if (!isEdit && !isNewAdd) {
      return;
    }
    const name = event.target.name;
    let value = event.target.value;
    const inputType = event.target.type;
    if (value && inputType === "number") {
      value = parseInt(value);
    }
    if (errorFields.includes(name) && ![undefined, null, ""].includes(value)) {
      setErrorFields((prevState) => prevState.filter((key) => key !== name));
    }
    setVendorState((prevState) => ({ ...prevState, [name]: value }));
  };

  useEffect(() => {
    setIsEdit(locationState?.edit || false);
    setIsNewAdd(locationState?.add || false);

    const fetchingInfo = async () => {
      setFetchLoading(true);
      try {
        if (locationState?.add) {
          // If only add data then fetch the id
          const latestId = await fetchLatestId(COLLECTION_COUNTER.VENDOR);
          setVendorState((prevState) => ({
            ...prevState,
            [vendorData.vendorId.key]: latestId,
          }));
        } else {
          // For view and edit data
          const docRef = doc(db, COLLECTION.VENDOR, vendorDocId);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            const storedData = docSnap.data();
            setVendorState((prevState) => {
              const stateData = { ...prevState };
              for (const key in stateData) {
                if (storedData.hasOwnProperty(key)) {
                  stateData[key] = storedData[key];
                }
              }
              return stateData;
            });
          } else {
            throw new Error(
              "Unexpected error occurred the id does not exist in the collection"
            );
          }
        }
      } catch (error) {
        console.log("error", error);
        setErrorOnFetch(true);
      }
      setFetchLoading(false);
    };
    fetchingInfo();
  }, []);

  // Callback to handle file upload
  const handleFileUpload = (file) => {
    setUploadedFile(file);
    console.log("Uploaded File:", file); 
  };

  const handleImageUpload = (file) => {
    setUploadedImage(file);
    console.log("Uploaded Image:", file); 
  };

  return (
    <>
      <Layout
        isNewAdd={isNewAdd}
        isEdit={isEdit}
        setIsEdit={setIsEdit}
        getVendorInput={getVendorInput}
        vendorState={vendorState}
        handleSubmitModal={handleSubmitModal}
        errorFields={errorFields}
        fetchLoading={fetchLoading}
        submitLoading={submitLoading}
        errorOnFetch={errorOnFetch}
        onFileUpload={handleFileUpload}
        onImageUpload={handleImageUpload}

      />
    </>
  );
};

export default VendorInfo;
